import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.StartPage.StartKyc', {
    youDontHaveWallets: 'You do not have any wallets',
    inOrderToCreate: 'In order to create wallet please complete onboarding',
    start: 'Start onboarding',
});
